module.exports = __webpack_public_path__ + "img/图片2.4360b996.png";